import { render, staticRenderFns } from "./MyAccountShow.vue?vue&type=template&id=3486e181"
import script from "./MyAccountShow.vue?vue&type=script&lang=js"
export * from "./MyAccountShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports